export * from './get-information-chip-props';
